import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { BRAND_HEADER_HEIGHT } from '@/core/constants';

export interface HeaderProps {
  /** ロゴ画像URL（省略時はテキストのみ） */
  logo?: string;
  /** タイトルテキスト */
  title?: string;
  /** タイトル画像URL（指定時はtitleテキストの代わりに表示） */
  titleImage?: string;
  /** モバイル用タイトル画像URL（指定時はxs〜smでこちらを表示） */
  titleImageSm?: string;
  /** 右側のアクション（ハンバーガーメニュー等） */
  endAction?: ReactNode;
  /** ハンバーガーメニュークリック時のコールバック */
  onMenuClick?: () => void;
  /** ブランド共通グラデーションを使用（LP等） */
  useBrandGradient?: boolean;
}

export function Header({
  logo,
  title,
  titleImage,
  titleImageSm,
  endAction,
  onMenuClick,
  useBrandGradient = false,
}: HeaderProps) {
  const theme = useTheme();

  const gradient = useBrandGradient
    ? theme.runport?.gradient
    : theme.custom?.gradient || theme.runport?.gradient || theme.palette.primary.main;

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: gradient,
        height: BRAND_HEADER_HEIGHT,
      }}
    >
      <Toolbar
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          height: BRAND_HEADER_HEIGHT,
          minHeight: BRAND_HEADER_HEIGHT,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
          {logo && <Box component="img" src={logo} alt="" sx={{ width: 40, height: 40, objectFit: 'contain' }} />}
          {titleImage ? (
            <>
              {titleImageSm && (
                <Box
                  component="img"
                  src={titleImageSm}
                  alt=""
                  sx={{ display: { xs: 'block', sm: 'none' }, height: 'auto', maxHeight: 48, objectFit: 'contain' }}
                />
              )}
              <Box
                component="img"
                src={titleImage}
                alt=""
                sx={{
                  display: titleImageSm ? { xs: 'none', sm: 'block' } : 'block',
                  height: 'auto',
                  maxHeight: 48,
                  objectFit: 'contain',
                }}
              />
            </>
          ) : (
            title && (
              <Typography variant="h6" component="h1" sx={{ fontWeight: 600, color: '#fff' }}>
                {title}
              </Typography>
            )
          )}
        </Box>
        {endAction}
        {onMenuClick && (
          <IconButton edge="end" aria-label="メニューを開く" onClick={onMenuClick} sx={{ color: '#fff' }}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
}
